export default "__VITE_ASSET__leC$FQBz__"